import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { ModalAppBankAccount } from '../../components/upeosoft/ModalApp/ModalApp';
import { deleteAccount, getBankAccount } from '../../network/bankAccount';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';

const BankAccount = ({ t }) => {
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { message } = App.useApp();
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteAccount(id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message ? data?.message : 'Deleted successfully');
        client.invalidateQueries({ queryKey: [queryKeys.getBankAccount] });
      },
      onError: () => {
        message.error('Something went wrong');
      },
    }
  );
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getBankAccount],
    queryFn: () => getBankAccount(),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + 'BNPI',
      icon: <MdModeEditOutline />,
      onClick: () => {
        setEditId(record?.name);
        setOpen(true);
        setEdit(true);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>{t.Delete} BNPI</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.AccountName,
      dataIndex: 'account_name',
      key: 'account_name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record?.account).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.Account,
      dataIndex: 'account',
      key: 'account',
    },
    {
      title: t.Bank,
      dataIndex: 'bank',
      key: 'bank',
    },
    {
      title: t.BankAccountNo,
      dataIndex: 'bank_account_no',
      key: 'bank_account_no',
    },
    {
      title: t.BranchCode,
      dataIndex: 'branch_code',
      key: 'branch_code',
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setEditId(record?.name);
                setOpen(true);
                setEdit(true);
              }}
            >
              <Button size="small" type="primary">
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: item?.name,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.Finance} subTitle="BNPI" path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
                setEdit(false);
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.AddBankAccount}
            </Button>
          }
        />
      </div>

      <ModalAppBankAccount
        open={open}
        setOpen={setOpen}
        setEditId={setEditId}
        setEdit={setEdit}
        edit={edit}
        editId={editId}
        t={t}
      />
    </div>
  );
};

export default BankAccount;
